import { Empty } from 'antd';
import { useIntl } from 'react-intl';

import AttendanceJourneyTimeline from '@src/components/AttendanceJourneyTimeline';
import type { AttendanceJourneyTimelineItem } from '@src/models/interfaces/attendanceJourneyTimeline.interface';
import IntlMessages from '@src/util/IntlMessages';

import type {
  MarkAttendanceJourneyDetails,
  MarkAttendanceSelectedUser,
} from '../types';
import MarkAttendanceJourneyInfo from './MarkAttendanceJourneyInfo';

import styles from '../MarkAttendanceDrawer.module.less';

type MarkAttendanceInProgressStepProps = {
  user: MarkAttendanceSelectedUser;
  journeyDetails: MarkAttendanceJourneyDetails | null;
  journeyTimeline: AttendanceJourneyTimelineItem[];
  error?: string | null;
};

/** Step 2B — journey already started (or SHIFT_START just succeeded locally). */
const MarkAttendanceInProgressStep = ({
  user,
  journeyDetails,
  journeyTimeline,
  error,
}: MarkAttendanceInProgressStepProps) => {
  const intl = useIntl();

  return (
    <div className={styles.stepBody}>
      <div className={styles.confirmHeader}>
        <h3 className={styles.confirmTitle}>
          <IntlMessages id="workJourney.realTime.markAttendance.title" />
        </h3>
      </div>

      {error ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={intl.formatMessage({
            id: 'workJourney.realTime.markAttendance.journeyLoadError',
          })}
        />
      ) : (
        <>
          <MarkAttendanceJourneyInfo user={user} journeyDetails={journeyDetails} />
          {journeyTimeline.length > 0 ? (
            <div className={styles.timelineSection}>
              <AttendanceJourneyTimeline items={journeyTimeline} />
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default MarkAttendanceInProgressStep;
